import { Combobox } from '@/components/combobox';
import type { PlatformFilter } from '@/types/state/filter';
import { PLATFORM_FILTERS } from '@/utils';

type PlatformFilterProps = {
  onApply: (selectedPlatforms: PlatformFilter[]) => void;
  onOpen?: () => void;
};

const PlatformFilter = ({ onApply, onOpen }: PlatformFilterProps) => {
  const handleApply = (selectedPlatforms: PlatformFilter[]) => {
    onApply(selectedPlatforms);
  };

  const handleOpen = () => {
    onOpen?.();
  };

  return (
      <Combobox
        options={PLATFORM_FILTERS?.map((platform) => ({
          id: platform.id,
          name: platform.label,
        }))}
        onOpen={handleOpen}
        onSelect={(selectedOptions) => {
          handleApply(selectedOptions.map((option) => ({ id: option.id, label: option.name })));
        }}
        defaultPlaceholder="Platforms: All"
        placeholder="Platforms:"
        className="z-elevated w-full"
        width={{ desktop: undefined }}
      />
  );
};

export default PlatformFilter;
